module.exports = __webpack_public_path__ + "static/media/rain.31922cd6.jpeg";